"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responsiveDialogClasses = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const classes = (0, _mui.generateUtilityClasses)('ResponsiveDialog', ['drawerCloseButton', 'drawer', 'drawerTitleContainer', 'drawerTitle', 'drawerFooter', 'dialog', 'dialogFooter', 'footer', 'dialogContent', 'drawerContent', 'content']);
const responsiveDialogClasses = exports.responsiveDialogClasses = {
  dialogCloseButton: _components.dialogClasses.closeButton,
  dialogTitle: _components.dialogClasses.header,
  ...classes
};
